/* unplugin-vue-components disabled */import script from "./EditTeamPriceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTeamPriceModal.vue?vue&type=script&setup=true&lang=js"

import "./EditTeamPriceModal.vue?vue&type=style&index=0&id=6ada452c&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ada452c"]])

export default __exports__